import { render, staticRenderFns } from "./TTTextInput.vue?vue&type=template&id=381d7006&"
import script from "./TTTextInput.vue?vue&type=script&lang=js&"
export * from "./TTTextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports